import { render, staticRenderFns } from "./OrganisationSettingsPage.vue?vue&type=template&id=308e21f0"
import script from "./OrganisationSettingsPage.vue?vue&type=script&lang=js"
export * from "./OrganisationSettingsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308e21f0')) {
      api.createRecord('308e21f0', component.options)
    } else {
      api.reload('308e21f0', component.options)
    }
    module.hot.accept("./OrganisationSettingsPage.vue?vue&type=template&id=308e21f0", function () {
      api.rerender('308e21f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/OrganisationSettingsPage.vue"
export default component.exports